export default __webpack_public_path__ + "static/media/group.3ddcfc11.svg";